<template>
  <div style="width:100%">
   <el-table :data="[props.rowData]">
      <el-table-column v-for="obj in header" :key="obj.name" :property="obj.name" :label="obj.title" ></el-table-column>
    </el-table>

<br/>
<!-- (formula?formula:changee):10000 -->
    <el-input-number
      v-model="changer"
      :min="0"
      :step="0.5"
      :max="target==='qtyreduce'?changee:10000000"
    ></el-input-number>
    <br/>
    <br/>
    <el-input
      type="textarea"
      :autosize="{ minRows:3}"
      :autofocus="true"
      placeholder="备注remark"
      v-model="theremark"
      maxlength="50"
      show-word-limit
    ></el-input>
    <p></p>
    <el-button type="success" @click="editdone">完成done</el-button>
  </div>
</template> 

<script>
import { fieldsprocess } from "zxg-table-fieldsprocess";
export default {

  props: ["props","actionobj","target", "index"],

  watch: {
    // index() {
      
    //   let doc = this.$store.state[this.target][this.index];
    //   this.doc = doc;
    //   this.changer = doc[this.actionobj.changer]||doc.number;
    //   this.changee=doc[this.actionobj.changee]||doc.qty;
    //   this.formula=eval(this.actionobj.formula)
      
    //   this.theremark=doc.remark
    // }
  },
  data() {
    let doc = this.$store.state[this.target][this.index];

    return {
      // formula:eval(this.actionobj.formula),
      doc: doc,
      changer:doc[this.actionobj.changer]||doc.number,
      changee:doc[this.actionobj.changee]||doc.qty,
      theremark:doc.remark
    };
  },
  computed:{
    header(){
      // console.log(fieldsprocess(this.$store.state.currentheader,"pure"))
      return fieldsprocess(this.$store.state.currentheader,"pure",this.$store)
    }
  },
  methods: {
    editdone() {
      let obj1 = {
        target: this.target,
        index: this.index,
        key: this.actionobj.changer||"number",
        value: this.changer
      };  
      let obj2 = {
        target: this.target,
        index: this.index,
        key: "remark",
        value: this.theremark
      };
      this.$store.commit("setvalue", obj1);
      this.$store.commit("setvalue", obj2);
      this.$emit("edited");
      this.$forceUpdate();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/actionoutin/qtyedit.vue